var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 9
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 9,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 14,
    height: 1,
    fill: "#E02626"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 14,
    height: 1,
    fill: "#E02626"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 14,
    height: 1,
    fill: "#E02626"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 14,
    height: 1,
    fill: "#E02626"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1,
    fill: "#E02626"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -1,
    width: 6,
    height: 5,
    fill: "#3F36A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1L1.61226 1.34549H1.97553L1.68164 1.55902L1.79389 1.90451L1.5 1.69098L1.20611 1.90451L1.31836 1.55902L1.02447 1.34549H1.38774L1.5 1Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2L1.61226 2.34549H1.97553L1.68164 2.55902L1.79389 2.90451L1.5 2.69098L1.20611 2.90451L1.31836 2.55902L1.02447 2.34549H1.38774L1.5 2Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1L2.61226 1.34549H2.97553L2.68164 1.55902L2.79389 1.90451L2.5 1.69098L2.20611 1.90451L2.31836 1.55902L2.02447 1.34549H2.38774L2.5 1Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2L2.61226 2.34549H2.97553L2.68164 2.55902L2.79389 2.90451L2.5 2.69098L2.20611 2.90451L2.31836 2.55902L2.02447 2.34549H2.38774L2.5 2Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1L3.61226 1.34549H3.97553L3.68164 1.55902L3.79389 1.90451L3.5 1.69098L3.20611 1.90451L3.31836 1.55902L3.02447 1.34549H3.38774L3.5 1Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2L3.61226 2.34549H3.97553L3.68164 2.55902L3.79389 2.90451L3.5 2.69098L3.20611 2.90451L3.31836 2.55902L3.02447 2.34549H3.38774L3.5 2Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnIcon);
export default __webpack_public_path__ + "static/media/en-icon.fbeaaf690676f60faa40de5575b0809e.svg";
export { ForwardRef as ReactComponent };